import {
  http
} from '../../config';
import base from '../base';

export const scheduledClasses={
  getScheduledClassesList(data){//获取排课课程列表
    return http({
      url:`${base.users}/teacherProxy/queryScheduledClassesList`,
      method:'post',
      data
    });
  },
  queryAssessReport(datebookId){//查看测评报告
    return http({
      url:`${base.users}/teacherProxy/queryAssessReport/${datebookId}`,
      method:'get',
    });
  },
  getScheduledTutorList(){
    return http({
      url:`${base.users}/teacherProxy/queryScheduledClassesSelectList`,
      method:'post'
    });
  },
  getScheduledStudentDetail(data){
    return http({
      url:`${base.users}/teacherProxy/queryScheduledStudentDetailsList`,
      method:'post',
      data
    });
  },
  getScheduledVideo(datebookId){//老师代理端-录像
    return http({
      url:`${base.datebook}/teaAgentClass/playRecord/${datebookId}`,
      method:'get',
      hideMessage:true,
    });
  },
  getinspectorClass(datebookId){//老师代理端-巡视
    return http({
      url:`${base.datebook}/teaAgentClass/inspectorClass/${datebookId}`,
      method:'get',
      hideMessage:true,
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/agent-api/scheduledClasses.js